import { useContext } from 'react';
import { Context } from '../../../DataStore';

import * as strings from '../../../data/strings';

import '../../../styles/marketing/v2/ContentSection.scss';

const ContentSection = (props) => {
  const { store } = useContext(Context);

  return (
    <div className="ContentSection">
      <div className="contentWrapper">
        <div className="content">
          <div className="contentBar left">
            <div className="textWrapper">
              <div className="textHeadline">
                {strings.default[store.language].Marketing.AIAssistedDiscussions}
              </div>
              <div className="textSubtext">
                {strings.default[store.language].Marketing.AIAssistedDiscussionsDescription}
                <br/><br/>
                {strings.default[store.language].Marketing.AIAssistedDiscussionsDescription2}
              </div>
              <div className="contentLink">
                <a 
                  className="link" 
                  href="https://youtu.be/AowwVKyCY0g"
                  target="_blank" 
                  rel="noreferrer">
                    🎥{strings.default[store.language].Marketing.WatchHow} &gt;
                  </a>
              </div>
            </div>
          </div>
          <div className="contentBar left">
            <div className="contentImageWrapper">
              <img
                className="contentImage"
                src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/section-1-record.png`}
                alt="Record anything" />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="contentBar right">
            <div className="textWrapper">
              <div className="textHeadline">
                {strings.default[store.language].Marketing.KeywordsInsights}
              </div>
              <div className="textSubtext">
                {strings.default[store.language].Marketing.KeywordsInsightsDescription}
                <br/><br/>
                {strings.default[store.language].Marketing.KeywordsInsightsDescription2}
              </div>
              {/*<div className="contentLink">
                <a 
                  className="link" 
                  href="https://youtu.be/MpU0pEx1Z1Y"
                  target="_blank" 
                  rel="noreferrer">
                    Watch Gravity in action &gt;
                  </a>
              </div>*/}
            </div>
          </div>
          <div className="contentBar right">
            <div className="contentImageWrapper">
              <img
                className="contentImage"
                src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/section-1-keywords.png`}
                alt="Record anything" />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="contentBar left">
            <div className="textWrapper">
              <div className="textHeadline">
                {strings.default[store.language].Marketing.DifferentiatedLearning}
              </div>
              <div className="textSubtext">
                {strings.default[store.language].Marketing.DifferentiatedLearningDescription}
                <br/><br/>
                {strings.default[store.language].Marketing.DifferentiatedLearningDescription2}
              </div>
            </div>
          </div>
          <div className="contentBar left">
            <div className="contentImageWrapper">
              <div className="aiTools">
                <img 
                  className="gif" 
                  src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}gif/ai-tools.gif`}
                  alt="AI Tools" />
              </div>
              <img
                className="contentImage"
                src={`${process.env.REACT_APP_CF_MKT_ENDPOINT}png/section-1-share${props.sector}.png`}
                alt="Record anything" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContentSection;
